/* eslint camelcase: 0 */
import { FormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 0

export const SingleSelectFormControl = styled(FormControl)<{
  is_opened: string
  is_disabled: string
}>`
  background: transparent;
  outline: none !important;
  border: none !important;
  height: 48px;
  border-radius: ${theme.attributes.borderRadius.tertiary};

  .MuiInputLabel-root {
    color: ${theme.colors.dropdownLabel} !important;
    font-family: Quicksand, sans-serif !important;
    font-size: 12px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    border: 0 !important;
    outline: 0 !important;
  }

  .MuiOutlinedInput-root {
    outline: none !important;
    border: none !important;
    width: 100%;
    height: 48px;
    padding-left: 16px;
    padding-right: 16px;
    background: transparent;
    color: ${theme.colors.cta};
    text-align: left;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    text-transform: capitalize;
    cursor: ${({ is_disabled }) => (is_disabled === 'true' ? 'default' : 'pointer')};
    text-overflow: ellipsis;
    overflow: hidden;

    &:hover {
      fieldset {
        border-color: ${theme.colors.cta} !important;
      }

      border-color: ${theme.colors.cta} !important;
    }

    .MuiSelect-select {
      padding: 0 !important;
      color: ${theme.colors.cta};

      > * {
        border: none !important;
        outline: none !important;
      }
    }

    .MuiSelect-nativeInput {
      cursor: pointer;
    }

    svg {
      transition: all 0.5s ease-in-out;
      cursor: pointer;
      right: 16px;
    }

    fieldset {
      color: ${theme.colors.dropdownLabel} !important;
      font-family: Quicksand, sans-serif !important;
      font-size: 12px !important;
      font-style: normal !important;
      font-weight: 500 !important;
      line-height: 12px !important;
      border-radius: 12px !important;
      border: 1px solid ${theme.colors.dropdownBorder};

      &:hover {
        border-color: ${theme.colors.cta} !important;
      }
    }

    &.Mui-focused {
      fieldset {
        color: ${theme.colors.dropdownLabel} !important;
        font-family: Quicksand, sans-serif !important;
        font-size: 12px !important;
        font-style: normal !important;
        font-weight: 500 !important;
        line-height: 12px !important;
        border-radius: 12px !important;
        border: 1px solid ${theme.colors.cta};
      }

      .MuiInputLabel-root {
        color: ${theme.colors.dropdownLabel} !important;
        font-family: Quicksand, sans-serif !important;
        font-size: 12px !important;
        font-style: normal !important;
        font-weight: 500 !important;
        border: 0 !important;
        outline: 0 !important;
      }
    }
  }

  &:hover {
    .MuiOutlinedInput-root {
      color: ${theme.colors.cta} !important;
    }

    svg {
      path {
        stroke: ${theme.colors.cta} !important;
      }
    }
  }

  ${({ is_disabled }) =>
    is_disabled === 'true' &&
    `
      opacity: 0.38;
      pointer-events: none;
      cursor: default;
      
      &:hover {
        background: transparent;

        .MuiOutlinedInput-root {
          color: ${theme.colors.cta};
        }
      }
      
      .MuiOutlinedInput-root {
        color: ${theme.colors.cta};
      }
  `};

  ${({ is_opened }) =>
    is_opened === 'true' &&
    `
      outline: 0;
      
      .MuiOutlinedInput-root {
        color: ${theme.colors.cta};
      }
      
      svg {
        transform: rotate(180deg);

        path {
          stroke: ${theme.colors.cta} !important;
        }
      }
  `};
`

export const CategoryMenuProps = {
  PaperProps: {
    sx: {
      cursor: 'default',
      background: theme.colors.menuBg,
      boxShadow: theme.attributes.boxShadow.navigation,
      borderRadius: theme.attributes.borderRadius.tertiary,
      width: '100%',
      minWidth: 'unset',
      padding: 0,

      '.MuiList-root': {
        padding: 0
      },

      '.MuiMenuItem-root': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minWidth: '167px',
        height: '48px',
        padding: `${theme.spacing.sm}px ${theme.spacing.small}px`,

        '&:first-of-type': {
          paddingTop: '16px'
        },

        '&:last-of-type': {
          paddingBottom: '16px'
        },

        img: {
          marginRight: `${theme.spacing.xSmall}px`
        },

        '.current-year': {
          color: theme.colors.dropdownLabel,
          textAlign: 'center',
          fontFamily: 'Quicksand, sans-serif',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: '0.1px',
          marginLeft: '6px',
          width: 'fit-content',
          display: 'flex',
          flexGrow: 1
        },

        '.current-year-svg': {
          minWidth: '14px',
          maxWidth: '14px',
          minHeight: '14px'
        },

        '&:hover': {
          background: theme.colors.menuItemHover,

          '.MuiListItemText-root .MuiTypography-root': {
            color: `${theme.colors.cta}`
          }
        },

        '.MuiCheckbox-root': {
          marginRight: `${theme.spacing.xSmall}px`,

          '&.Mui-checked': {
            svg: {
              path: {
                fill: theme.colors.textPrimary
              }
            }
          },

          '&:hover': {
            borderRadius: theme.attributes.borderRadius.large,
            background: 'rgba(202, 196, 208, 0.12)'
          },

          svg: {
            width: '18px',
            height: '18px',

            path: {
              fill: theme.baseColors.greyscale[80]
            }
          }
        },

        '.MuiListItemText-root': {
          flex: 'unset'
        },

        '.MuiListItemText-root .MuiTypography-root': {
          fontFamily: theme.typography.fontFamily.primary,
          fontWeight: theme.typography.fontWeight.bold,
          fontSize: theme.typography.fontSize.large,
          color: theme.colors.foreground,
          lineHeight: '22px',
          fontStyle: 'normal',
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        },

        '&.Mui-selected': {
          background: `${theme.colors.surfaceContainerBackground}`
        },

        '&[aria-selected="true"]': {
          '.MuiListItemText-root .MuiTypography-root': {
            color: `${theme.colors.cta}`
          }
        }
      },

      '&::-webkit-scrollbar': {
        width: '4px',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-track': {
        boxShadow: 'none',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#FBD8F5',
        borderRadius: theme.attributes.borderRadius.secondary
      }
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
